import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import 'dayjs/locale/ja'
import { DashboardPageLayout } from '@/components/layouts/dashboard-page-layout'
import { ReportPeriods } from '@/models/report'
import { useForceUpdate } from '@/hooks/use-force-update'
import { ExportHistory } from '@/components/organisms/reports-manager/export-history'
import { StateToggleTab } from '@/components/molecules/settings/state-toggle-tab'
import { CustomPeriodReportForm } from '@/components/organisms/reports-manager/custom-period-report-form'
import { DailyReportForm } from '@/components/organisms/reports-manager/daily-report-form'
import { MonthlyReportForm } from '@/components/organisms/reports-manager/monthly-report-form'
import { YearlyReportForm } from '@/components/organisms/reports-manager/yearly-report-form'
import * as ReportModel from '@/models/report'
import { useForm } from 'react-hook-form'
import dayjs from 'dayjs'
import { ReservationNoteCategory } from '@/models/reservation/reservation-note'
import { ReportFormType } from '@/features/report-manager/report-manager-slice'

export const ReportsManager: React.FC = () => {
  const { t, i18n } = useTranslation()
  const [reportPeriod, setReportPeriod] = useState<ReportPeriods>(ReportPeriods.custom)
  const forceUpdate = useForceUpdate()

  const formReturn = useForm<ReportFormType>({
    defaultValues: {
      type: ReportModel.ReportTypes.dailyOperations,
      format: 'pdf',
      date: dayjs().format('YYYY-MM-DD'),
      month: dayjs().format('YYYY-MM-DD'),
      period: {
        startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
      },
      isIncludeTax: '1',
      subjectCodes: [],
      noteCategory: ReservationNoteCategory.Front,
    },
  })

  useEffect(() => {
    forceUpdate()
  }, [i18n.language])

  return (
    <DashboardPageLayout title={t('Reports')}>
      <>
        <StateToggleTab
          tabs={[
            { name: 'カスタム期間', value: ReportPeriods.custom },
            { name: '日次レポート', value: ReportPeriods.day },
            { name: '月次レポート', value: ReportPeriods.month },
            { name: '年次レポート', value: ReportPeriods.year },
          ]}
          currentTab={reportPeriod}
          onChange={setReportPeriod}
          customTabStyle={css({ width: 160 })}
        />
        {reportPeriod === ReportPeriods.custom && <CustomPeriodReportForm formReturn={formReturn} />}
        {reportPeriod === ReportPeriods.day && <DailyReportForm formReturn={formReturn} />}
        {reportPeriod === ReportPeriods.month && <MonthlyReportForm formReturn={formReturn} />}
        {reportPeriod === ReportPeriods.year && <YearlyReportForm formReturn={formReturn} />}
        <ExportHistory />
        <div style={{ paddingBottom: 24 }}></div>
      </>
    </DashboardPageLayout>
  )
}
